const getters = {
  getMe: state => state.me,
  getUsers: state => state.users,
  getHourAppUser: state => state.hourAppUser
}


export default getters